/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-dupe-keys */
import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import bg from "../img/bg.png";
// import score_individual from "../img/score_individual1.jpg";
// import running from "../img/running.png"
import monitor from "../img/monitor.png";
import "./PageLogin.css";
import { useNavigate } from "react-router-dom";
import ModalAddExercise from "../components/ModalAddExercise";
import ModalScore from "../components/ModalScore";
import Swal from "sweetalert2";
import "../components/style.css";
import ModalQRCodeUser from "../components/ModalQRCodeUser";
import { FaTrash, FaBell, FaLock } from "react-icons/fa";
import { Table } from "react-bootstrap";
import add_exercise from "../img/add_exercise.jpg";
import Button from "react-bootstrap/Button";
import { scrollToElement,thai_date, handleResizeDisplay, checkGroupsUser, getlocalStorage, formatdate, showLoading, hideLoading } from '../function/functionALL';
import ModalPagination from '../components/ModalPagination'
import LoadingTable from '../components/LoadingTable'
import CheckNoContent from '../components/CheckNoContent'
import running from "../img/running.png"
import Layout from '../components/Layout';
require("moment/locale/th");

const PageHome = () => {
  const navigate = useNavigate();

  const [TestRound, setTestRound] = useState([]);
  const [searchInputvalue, setSearchInputvalue] = useState("");
  const [loadingTable, setloadingTable] = useState(true); ////ทำงาน
  const [pageNumber, setPageNumber] = useState(1);
  const [isSearch, setIsseach] = useState(false);
  const [paginationNext, setpaginationNext] = useState([]);
  const [AmoutData, setAmoutData] = useState();
  const [isStacked, setIsStacked] = useState(false);
  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups)
  const role_openRole = role?.openRole
  const topRef = useRef(null);
  //get data
 
  const setRound = async () => {

    try {
      scrollToElement(topRef)
      isSearch ? setloadingTable(true) : null; //
      await Axios.get(process.env.REACT_APP_API_TESTROUND, {
        headers: {
          Authorization: "Token " + Token,
        },
      })
        .then((res) => {
          setTestRound(res.data.results);
          setpaginationNext(res.data);
          setAmoutData(res.data.count);
          setloadingTable(false);

        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
            
        });
        })
        
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        
    });

    } 
  };

  //useEffect seach round
  useEffect(() => {
    if (searchInputvalue) {
      setIsseach(false);
      setDataSearch();
      handleResizeDisplay(setIsStacked);
    } else {
      setRound();
      handleResizeDisplay(setIsStacked);

    }
  }, [isSearch]);

  ///convert budget_year
  const TestRoundbuddhist = TestRound.map((obj) => {
    const buddhistYear = obj.budget_year + 543;
    return { ...obj, budget_year: buddhistYear };
  });

  //confirmDelete round
  const confirmDelete = (id, budget_year, round, date) => {
    Swal.fire({
      title: "ยืนยันการลบ",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      cancelButtonText: "ยกเลิก",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "ยืนยันการลบ",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id, budget_year, round, date);
      }
    });
  };
  //Delete round
  const handleDelete = (id) => {
    showLoading();

    Axios.delete(process.env.REACT_APP_API_TESTROUND + `${id}/`, {
      headers: {
        Authorization: "Token " + Token,
      },
    })
      .then((res) => {

       
          hideLoading();

          Swal.fire({
            icon: "success",
            title: "ลบข้อมูลสำเร็จ",

          })
          setRound();
          setloadingTable(true)
       

      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");

          navigate(
            "/notfound404"
          );
        }

        else {
          console.log("Error: ", err.response.data.detail);
          hideLoading();

          Swal.fire({
            icon: "error",
            title: "ลบวงรอบไม่สำเร็จ"
          });
        }
        console.error(err);
        Swal.fire({
          icon: "error",
          
      });
      });
  };

  const AmountPage = Math.ceil(AmoutData / 25);
  //paginationNext
  const handlePageChange = (pageNumber) => {
    setPageNumber(pageNumber);
    setloadingTable(true)

    //เลื่อนขึ้นไปดานบน
    scrollToElement(topRef)

    if (pageNumber === 1) {
      Axios.get(process.env.REACT_APP_API_TESTROUND, {
        headers: {
          Authorization: "Token " + Token,
        },
      })
        .then((res) => {
          setloadingTable(false)
          res.data.results.sort((a, b) => a.rank_id - b.rank_id);
          setTestRound(res.data.results);
          setpaginationNext(res.data);
          setAmoutData(res.data.count);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");

            navigate(
              "/notfound404"
            );
          }
          console.error(err);
          Swal.fire({
            icon: "error",
            
        });
        });
    } else {
      setloadingTable(true)
      let offset = 25 * (pageNumber - 1);
      let paginationNext =
        process.env.REACT_APP_API_TESTROUND + `?limit=25&offset=${offset}`;
      Axios.get(paginationNext, {
        headers: {
          Authorization: "Token " + Token,
        },
      })
        .then((res) => {
          setloadingTable(false)
          setTestRound(res.data.results);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");

            navigate(
              "/notfound404"
            );
          }
          console.error(err);
          Swal.fire({
            icon: "error",
            
        });
        });
    }
  };
  //seach
  const setDataSearch = async (e) => {
    const arrSearch = await TestRoundbuddhist.filter((row) => {
      const { budget_year, unit_name } = row;
      const searchStr = searchInputvalue.toLowerCase();
      return (
        (budget_year &&
          budget_year.toString().toLowerCase().includes(searchStr)) ||
        (unit_name && unit_name.includes(searchStr))
      );
    });

    const DataTestRoundbuddhist = arrSearch.map((obj) => {
      const buddhistYear = obj.budget_year - 543;
      return { ...obj, budget_year: buddhistYear };
    });

    if (arrSearch.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "ไม่พบข้อมูล หรือค้นหาในหน้าอื่น",
      });
    }
    setTestRound(DataTestRoundbuddhist);

  };

  const searchValue = async (e) => {
    e.preventDefault();

    if (searchInputvalue.length >= 3) {
      setIsseach(true);
      setDataSearch();

    } else if (searchInputvalue.length < 3) {
      Swal.fire({
        icon: "warning",
        title: "กรุณาค้นหา 3 ตัวอักษรขึ้นไป",
      });
    }
  };

  const handleChangeSearch = async (e) => {
    const txt = await e.target.value;
    if (txt === "") {
      setRound();
      setSearchInputvalue("");
    } else {
      setSearchInputvalue(txt);
    }
  };
  //showscore
  const showButton = () => {
    return (
      <Link
        to={`/PageScoreUser`}
        className={
          "col-12 d-flex  p-1 mt-2 mt-md-0"
        }
      >
        <Button
          style={{ width: "100%", background: "#7B97E1", border: "none" }}
        >
          <div className="row col-12 p-0 m-0 justify-content-center">
            <div className="col-3 col-sm-12 col-lg-12 text-center ">
              <img
                src={monitor}
                style={{
                  maxHeight: "50px",
                  objectFit: "cover",
                }}
              />
            </div>
            <div className="col-8  col-sm-12 mt-lg-3 d-flex align-items-center justify-content-center text-center ">
              ผลการทดสอบรายบุคคล
            </div>
          </div>
        </Button>
      </Link>
      // </div>
    );
  };


  //-------------------------modaladdExercise--------------------

  const [budget_year, setbudget_year] = useState("");
  const [round, setround] = useState("");
  const [date, setdate] = useState("");
  const [chkEmpty, setChkEmpty] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const triggerButtonRef = useRef(null);
  const [dateshow_picker, setdateshow_picker] = useState("")

  const openModal = () => {
    setIsModalOpen(true);
  };

  const handleSave = (resultAddRound) => {
    showLoading();

    Axios.post(process.env.REACT_APP_API_TESTROUND, {
      budget_year: budget_year - 543,
      round: round,
      date: formatdate(date),
      // unit: DataLogin.unit_id,
      unit: DataToken_.work_unit_id,
      recorder: DataToken_.id,
      status: 1,
    }, {
      headers: {
        Authorization: "Token " + Token
      }
    })
      .then((res) => {
        hideLoading();
        Swal.fire({
          icon: 'success',
          title: 'เพิ่มวงรอบสำเร็จ',
        })
        setbudget_year("");
        setround("");
        setdate("");
        setdateshow_picker("")
        setIsModalOpen(false);
        setRound();
        setloadingTable(true)

        if (triggerButtonRef.current) {
          triggerButtonRef.current.focus();
        }

      })
      .catch((err) => {
        hideLoading();
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");
          navigate(
            "/notfound404"

          );
        }
        else{
          console.log("Error: ", err.response.data.detail);
          hideLoading();
          Swal.fire({
            icon: 'error',
            title: 'เพิ่มวงรอบไม่สำเร็จ',
          })
        }
        console.error(err);
        Swal.fire({
          icon: "error",
          
      });
      });

  };


  return (
    <>
<Layout>
      <div ref={topRef}>
      

        <Form>
          <div className="App login-box">
            <section
              style={{
                backgroundImage: `url(${bg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                minHeight: "1180px",
              }}
            >
              <div className="rounded pb-2" style={{ padding: "68px 0 0 0" }}>
                <div className="row col-12 col-sm-12 ms-0 justify-content-center pt-4">
                  <div className="col-sm-12 col-12 ">
                    <div
                      className="shadow-lg m-1 p-2 rounded min-w-50 "
                      style={{
                        maxHeight: "1000px",
                        backgroundColor: "#D0D9FF",
                        border: "1px solid  rgba(41, 43, 44, 0.1)",
                      }}
                    >
                      <div className="row col-12 m-0 mt-3 mb-3 ">
                        <div className="col-lg-8 col-sm-12 ">
                          <img
                            className="card-img-top rounded-top-right-1 d-flex "
                            src={add_exercise}
                            alt="tag"
                            style={{
                              maxHeight: "350px",
                              objectFit: "cover",
                            }}
                          />
                        </div>

                        {

                          role_openRole?.UnitAdmin ? (
                            <div className=" row col-sm-12  col-lg-4 m-0 ">

                              <div className="col-12 d-flex p-1 mt-2 mt-md-0" onClick={openModal}>
                                <Button style={{ width: "100%", background: "#8A80CE", border: "none" }} ref={triggerButtonRef}>

                                  <div className="row col-12 p-0 m-0 justify-content-center">
                                    <div className="col-3 col-sm-12 col-lg-12 text-center ">
                                      <img
                                        src={running}
                                        style={{
                                          maxHeight: "50px",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </div>
                                    <div className="col-8  col-sm-12 mt-lg-3 d-flex align-items-center justify-content-center text-center ">
                                      เพิ่มการทดสอบสมรรถภาพทางกาย
                                    </div>

                                  </div>
                                </Button>

                              </div>

                              {showButton()}
                            </div>
                          ) : role_openRole?.FunctionaryTester || role_openRole?.RTAFPersonAdmin ? (
                            <div className=" row col-sm-12  col-lg-4 m-0 ">
                              {showButton()}
                            </div>

                          ) : (
                            <ModalScore IdUser={DataToken_.id} NoneImg={true} />
                          )
                        }

                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-3 pb-0">
                  <div
                    className="card col-sm-12 col-xs-12 "
                    style={{ backgroundColor: "rgb(247, 247, 247, 0.68)" }}
                  >
                    <div className="card-body rounded">
                      <div className="row d-flex p-2 pt-3 pt-md-4">
                        <div
                          className="col-12 col-md-12 col-lg-9 card-title fw-bold text-center text-md-start p-1 ps-md-2 d-md-flex justify-content-between"
                          style={{ color: "#000000" }}
                        >
                          <span
                            className="fw-bold col-12 col-md-6 col-lg-7 justify-content-end"
                            style={{ color: "#000000", fontSize: "20px" }}
                          >
                            <b>รายการทดสอบ </b>
                            <b style={{ color: "#767676" }}>
                              (สังกัด : {DataToken_.work_unit}){" "}
                            </b>
                          </span>
                          <ModalQRCodeUser />
                        </div>
                        <div className="col-12 col-md-12 col-lg-3 has-validation p-1 justify-contents-end">
                          <div className="input-group w-auto">
                            <input
                              className="form-control"
                              placeholder={
                                role_openRole?.UnitAdmin
                                  ? "ค้นหา (ปีงบประมาณ)"
                                  : "ค้นหา (ปีงบประมาณ หรือหน่วย)"
                              }
                              onChange={(event) => handleChangeSearch(event)}
                            />
                            <button
                              className="input-group-text"
                              style={{
                                backgroundColor: "#9ca0ca",
                                fontWeight: "500",
                              }}
                              onClick={searchValue}
                            >
                              ค้นหา
                            </button>
                          </div>
                        </div>
                      </div>
                      {loadingTable ?
                        (
                          <LoadingTable />
                        ) :
                        TestRoundbuddhist.length === 0 ? (
                          <CheckNoContent />

                        ) : (

                          <Table
                            responsive
                            className={
                              isStacked
                                ? "table-stacked"
                                : "table_content table table-hover"
                            }
                          >
                            <thead>
                              <tr
                                style={{
                                  fontSize: "14px",
                                  textAlign: "center",
                                  width: "20%",
                                  minWidth: "200px",
                                  height: "60px",
                                  color: "white",
                                }}
                              >
                                <th
                                  scope="col"
                                  style={{
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                    width: "5%",
                                    color: "white",
                                    backgroundColor: "#666699",
                                  }}
                                >
                                  ลำดับ
                                </th>
                                <th
                                  scope="col"
                                  style={{

                                    textAlign: "center",
                                    color: "white",
                                    width: "8%",
                                    minWidth: "70px",
                                    verticalAlign: "middle",
                                    backgroundColor: "#666699",
                                  }}
                                >
                                  หน่วย
                                </th>
                                <th
                                  scope="col"
                                  style={{

                                    textAlign: "center",
                                    color: "white",
                                    width: "8%",
                                    minWidth: "80px",
                                    verticalAlign: "middle",
                                    backgroundColor: "#666699",
                                  }}
                                >
                                  รหัสวงรอบ
                                </th>
                                <th
                                  scope="col"
                                  style={{

                                    textAlign: "center",
                                    color: "white",
                                    width: "10%",
                                    minWidth: "140px",
                                    verticalAlign: "middle",
                                    backgroundColor: "#666699",
                                  }}
                                >
                                  ปีงบประมาณ / รอบที่
                                </th>
                                <th
                                  scope="col"
                                  style={{

                                    width: "12%",
                                    minWidth: "100px",
                                    textAlign: "center",
                                    color: "white",
                                    verticalAlign: "middle",
                                    backgroundColor: "#666699",
                                  }}
                                >
                                  วันทดสอบ
                                </th>
                                <th
                                  scope="col"
                                  style={{

                                    width: "10%",
                                    minWidth: "100px",
                                    textAlign: "center",
                                    color: "white",
                                    verticalAlign: "middle",
                                    backgroundColor: "#666699",
                                  }}
                                >
                                  จำนวนข้าราชการ
                                </th>
                                <th
                                  scope="col"
                                  style={{

                                    width: "10%",
                                    minWidth: "100px",
                                    textAlign: "center",
                                    color: "white",
                                    verticalAlign: "middle",
                                    backgroundColor: "#666699",
                                  }}
                                >
                                  ผู้ลงทะเบียน
                                </th>
                                <th
                                  scope="col"
                                  style={{

                                    width: "10%",
                                    minWidth: "100px",
                                    textAlign: "center",
                                    color: "white",
                                    verticalAlign: "middle",
                                    backgroundColor: "#666699",
                                  }}
                                >
                                  ผู้เข้ารับการทดสอบ
                                </th>
                                <th
                                  scope="col"
                                  style={{

                                    width: "10%",
                                    minWidth: "100px",
                                    color: "white",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                    backgroundColor: "#666699",
                                  }}
                                >
                                  การจัดการ
                                </th>
                                {role_openRole?.UnitAdmin ? (
                                  <th
                                    scope="col"
                                    style={{
                                      width: "10%",
                                      minWidth: "100px",
                                      textAlign: "center",
                                      color: "white",
                                      verticalAlign: "middle",
                                      backgroundColor: "RGB(255, 0, 0,0.60)",
                                    }}
                                  >
                                    ลบข้อมูล
                                  </th>
                                ) : (
                                  ""
                                )}
                              </tr>
                            </thead>
                            <tbody
                              style={{
                                backgroundColor: "rgb(247, 247, 247, 0.5)",
                              }}
                            >

                              {TestRoundbuddhist.map((Data, i) => (
                                <tr className="raw" key={i}>
                                  <td
                                    className="text-center"
                                    style={{
                                      fontSize: "16px",
                                      backgroundColor: "#d0d9ff",
                                      verticalAlign: "middle",
                                    }}
                                    data-label="ลำดับ"
                                  >
                                    {(pageNumber - 1) * 25 + i++ + 1}
                                  </td>
                                  <td
                                    className="text-center"
                                    data-label="หน่วย "
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    {Data.unit_name}{" "}
                                  </td>
                                  <td
                                    className="text-center"
                                    data-label="รหัสวงรอบ"
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    {Data.id}
                                  </td>

                                  <td
                                    className="text-center"
                                    data-label="ปีงบประมาณ / รอบที่"
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    {Data.budget_year} / {Data.round}
                                  </td>

                                  <td
                                    className="text-center"
                                    data-label="วันทดสอบ"
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    {thai_date(Data.date, "shortdate")}
                                  </td>
                                  <td
                                    className="text-center"
                                    data-label="จำนวนข้าราชการ"
                                    style={{
                                      verticalAlign: "middle",
                                      color: "#0062f8",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {Data.num_participant}
                                  </td>
                                  <td
                                    className="text-center"
                                    data-label="ผู้ลงทะเบียน"
                                    style={{
                                      verticalAlign: "middle",
                                      color: "#0062f8",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {Data.num_register}
                                  </td>
                                  <td
                                    className="text-center"
                                    data-label="ผู้เข้ารับการทดสอบ"
                                    style={{
                                      verticalAlign: "middle",
                                      color: "#0062f8",
                                      fontWeight: "800",
                                    }}
                                  >
                                    <div style={{ verticalAlign: "middle" }}>
                                      {Data.num_test}
                                      {Data.num_tester_today === 0 ? (
                                        " "
                                      ) : (
                                        <span
                                          style={{
                                            color: "#FFB545",
                                            fontWeight: "800",
                                          }}
                                        >
                                          {" "}
                                          ({Data.num_tester_today})
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                  <td
                                    className="text-center"
                                    data-label="การจัดการ"
                                    style={{ verticalAlign: "middle", backgroundColor: isStacked ? "RGB(2, 117, 216,0.10)" : "" }}
                                  >
                                    <div className="col-12 col-lg-12 col-sm-12 ">
                                      <Link
                                        to={`/PageTestRound`}
                                        state={{
                                          props_RoundTest: Data,
                                          status: Data.status,
                                        }}
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-primary "
                                          style={{
                                            fontSize: "16px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px",
                                            whiteSpace: "nowrap",
                                            minWidth: "150px",
                                            backgroundColor:
                                              "rgb(2, 117, 216,0.80)",
                                            border: "none",
                                          }}
                                        >
                                          <span>การทดสอบ</span>
                                          {Data.status === 0 ? (
                                            ""
                                          ) : (
                                            <>
                                              <style>{`
                                                @keyframes bellRing {
                                                  0% { transform: rotate(0deg); }
                                                  5% { transform: rotate(15deg); }
                                                  10% { transform: rotate(-12deg); }
                                                  15% { transform: rotate(10deg); }
                                                  20% { transform: rotate(-8deg); }
                                                  25% { transform: rotate(6deg); }
                                                  30% { transform: rotate(-4deg); }
                                                  35% { transform: rotate(2deg); }
                                                  40% { transform: rotate(0deg); }
                                                  100% { transform: rotate(0deg); }
                                                }
                                                .bell-ring {
                                                  display: inline-block;
                                                  transform-origin: top center;
                                                  animation: bellRing 1.6s ease-in-out infinite;
                                                  filter: drop-shadow(0 2px 4px rgba(0,0,0,.15));
                                                }
                                              `}</style>
                                              <FaBell
                                                className="bell-ring"
                                                style={{
                                                  color: "#F9F871",
                                                  fontSize: "18px",
                                                }}
                                              />
                                            </>
                                          )}
                                        </button>
                                      </Link>
                                    </div>
                                  </td>
                                  {role_openRole?.UnitAdmin ? (
                                    <td
                                      className="text-center"
                                      data-label="ลบข้อมูล"
                                      style={{ verticalAlign: "middle", backgroundColor: isStacked ? "RGB(255, 0, 0,0.10)" : "", }}
                                    >
                                      <div className="col-12 col-lg-12 col-sm-12 ">
                                        {Data.status === 0 ? (
                                          <button
                                            type="button"
                                            className="btn btn-secondary "
                                            disabled
                                            style={{
                                              border: "none",
                                              width: "122px",
                                            }}
                                          >
                                            <FaLock
                                              style={{
                                                color: "white",
                                                fontSize: "16px",
                                              }}
                                            />
                                          </button>
                                        ) : (
                                          <button
                                            type="button"
                                            className="btn btn-danger"
                                            style={{
                                              border: "none",
                                              width: "122px",
                                              backgroundColor:
                                                "RGB(255, 0, 0,0.60)",
                                            }}
                                            onClick={() =>
                                              confirmDelete(
                                                Data.id,
                                                Data.budget_year,
                                                Data.round,
                                                Data.date
                                              )
                                            }
                                          >
                                            <FaTrash
                                              style={{
                                                color: "white",
                                                fontSize: "14x",
                                              }}
                                            />
                                          </button>
                                        )}
                                      </div>
                                    </td>
                                  ) : (
                                    ""
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        )}

                      <ModalAddExercise
                        show={isModalOpen}
                        onSave={handleSave}
                        onClose={() => setIsModalOpen(false)}
                        setChkEmpty={setChkEmpty}
                        budget_year={budget_year}
                        setbudget_year={setbudget_year}
                        round={round}
                        setround={setround}
                        date={date}
                        setdate={setdate}
                        dateshow_picker={dateshow_picker}
                        setdateshow_picker ={setdateshow_picker}

                      />
                      <ModalPagination
                        pageNumber={pageNumber}
                        AmountPage={AmountPage}
                        handlePageChange={handlePageChange}
                      />

                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
         
        </Form>
       
      </div> </Layout>
    </>
  );
};

export default PageHome;
